import e from "react";
import t from "./index188.mjs";
import s from "./index171.mjs";
import { Progress as d } from "./index189.mjs";
import { Close as i } from "./index173.mjs";
const h = ({
  onClickBack: r,
  stepsLength: n,
  currentIndex: o,
  title: l,
  onClose: m
}) => {
  const c = (a) => {
    (a.key === "Enter" || a.key === " ") && (a.preventDefault(), r());
  };
  return /* @__PURE__ */ e.createElement("div", { "data-testid": "header", className: t.header }, /* @__PURE__ */ e.createElement("div", { className: t.header_content }, /* @__PURE__ */ e.createElement("div", { className: t.header_content_left }, /* @__PURE__ */ e.createElement(
    "button",
    {
      className: t.back,
      onClick: r,
      onKeyDown: c,
      "data-testid": "back-button",
      "aria-label": I18n.t("booking_engine.buttons.back"),
      type: "button"
    },
    /* @__PURE__ */ e.createElement(s, null)
  ), /* @__PURE__ */ e.createElement("h3", { "data-testid": "header-title" }, l)), /* @__PURE__ */ e.createElement(i, { onClose: m })), /* @__PURE__ */ e.createElement(d, { stepsLength: n, currentIndex: o }));
};
export {
  h as Header
};
